<template>
    <label :class="`radio radio__${type}${className !== '' ? ` ${className}` : ''}`">
        <input @change="onChangeRadio" type="radio" name="radio" :value="value" :checked="valueChecked === value" />
        <span class="radio-label">{{ getTranslatedText(label) }}</span>
    </label>
</template>
<script>
import EventBus from '@/utils/EventBus';
import languageMixins from '@/mixins/language-mixins';
import utilsMixin from '@/mixins/function-utils';

export default {
    mixins: [languageMixins, utilsMixin],
    props: {
        type: {
            type: String,
            default: 'default',
        },
        nameFunction: {
            type: String,
            default: '',
        },
        paramFunction: {
            type: String,
            default: '',
        },
        className: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            default: '',
        },
        valueChecked: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        isDisable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    methods: {
        onChangeRadio() {
            if (!this.isStrEmpty(this.nameFunction)) {
                EventBus.emit(this.nameFunction, this.paramFunction);
            } else {
                this.$emit('change:value', this.value);
            }
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/common/radio.scss';
</style>
